export enum IntakeFormType {
  EVICTION = 'EVICTION'
}
